import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M4.818 16.042h6.197c.47 0 .84-.39.747-.852-.259-1.272-1.104-3.523-3.845-3.523-2.742 0-3.587 2.25-3.846 3.523-.093.461.277.852.747.852Zm8.307-4.375c1.732 0 2.442 1.79 2.728 3.08.155.696-.409 1.295-1.122 1.295h-.773m-6.041-7.5a2.292 2.292 0 1 0 0-4.584 2.292 2.292 0 0 0 0 4.584Zm4.375 0c1.265 0 2.083-1.026 2.083-2.292 0-1.266-.818-2.292-2.083-2.292" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);